import axios from "axios"
import { toast } from "react-toastify"
import { AUTH_LOADING, AUTH_NOTIFICATION, LOGIN_FAIL, LOGIN_SUCCESS } from "../types"
export const setLoading = (val) => async (dispatch) => {
    dispatch({
        type: AUTH_LOADING,
        payload: val
    })
}
export const setAuthNotification = (val) => async (dispatch) => {
    dispatch({
        type: AUTH_NOTIFICATION,
        payload: val
    })
}

export const login = (obj) => async (dispatch) => {
    dispatch(setLoading(true))
    try {
        let form = new FormData()
        form.append('action', 'login')
        form.append('username', obj.username)
        form.append('password', obj.password)
        axios.post('https://bo.discovershurooq.ae/api/pos_api.php', form).then(res => {
            if (res.data.token) {
                dispatch({
                    type: LOGIN_SUCCESS,
                    payload: res.data.token,
                })
                dispatch(setAuthNotification('Login Success'))
                window.setTimeout(() => {
                    dispatch(setAuthNotification(''))
                }, 2500)
                dispatch(setLoading(false))
            } else {
                dispatch({
                    type: LOGIN_FAIL,
                })
                dispatch(setAuthNotification('Invalid Credentials'))
                window.setTimeout(() => {
                    dispatch(setAuthNotification(''))
                }, 2500)
                dispatch(setLoading(false))
            }
        })
    } catch (e) {
        // toast.warning(e.message)
        dispatch(setAuthNotification('Login Success'))
        window.setTimeout(() => {
            dispatch(setAuthNotification(''))
        }, 2500)
        dispatch(setLoading(false))
    }
}